import { IntlShape } from 'react-intl';

import { Error } from '../../../api/setup/getApiError';
import { Content, NotificationContent } from './types';

const errorsMap = (
  intl: IntlShape,
  content: NotificationContent | undefined,
  isError: boolean
): Content => {
  if (content && (content as Error).code) {
    return {
      title: intl.formatMessage({ id: 'app.error.title' }),
      description: intl.formatMessage({
        id: `app.error.${(content as Error).code}`,
        defaultMessage: intl.formatMessage({ id: 'app.error.000-000' })
      })
    };
  }

  if (content) {
    return {
      title: (content as Content).title,
      description: (content as Content).description
    };
  }

  return {
    title: intl.formatMessage({ id: `app.${isError ? 'error' : 'success'}.title` }),
    description: ''
  };
};

export default errorsMap;
